import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AlertClientService } from "@app2/clients/alert-client.service";
import { QueryTrigger } from "@app2/clients/types/alert-typedefs";
import { TriggerAlertsTableComponent } from "@app2/alert/alert-inbox/trigger-alerts-table.component";
import { StateParams, StateType } from "@app2/fraud/type-defs";
import { NotificationsService } from "@app2/shared/services/notifications.service";
import { HttpErrorResponse } from "@angular/common/http";
import { RouterService } from "@app2/shared/services/router.service";
import { getMessageForError } from "@app2/util/errors/handleable-errors";

@Component({
    selector: "single-trigger-display",
    template: `
        <ng-container *dsLoading="loading || loadingTrigger">
            <div *ngIf="!triggerId" class="vh-center-content" test-class="no-trigger-selected">
                {{ "SELECT_NEW_TRIGGER" | localize }}
            </div>
            <div *ngIf="triggerId" class="inbox-right-scrollable">
                <trigger-header *ngIf="trigger"
                                [currentTrigger]="trigger"
                                test-id="selected-trigger-header"></trigger-header>
                <section id="right-alert-list">
                    <trigger-details [currentTrigger]="trigger">
                    </trigger-details>
                    <trigger-alerts-table class="full-width"
                                          [trigger]="trigger"
                                          [state]="state"
                                          (onAlertsStateChanged)="onStateChanged($event)">
                    </trigger-alerts-table>
                </section>
            </div>
        </ng-container>
    `,
    host: {
        style: "display: contents;",
    },
})
export class SingleTriggerDisplayComponent implements OnChanges {

    @Input() triggerId: uuid;
    @Input() state: StateType;
    @Input() loading: boolean;
    // Emits the number of alerts remaining after a state change is performed
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onAlertsStateChanged = new EventEmitter<number>();

    @ViewChild(TriggerAlertsTableComponent) triggerAlertsTable;

    trigger: QueryTrigger;
    firstAlertTimestamp: date;
    loadingTrigger: boolean;

    constructor(private alertClient: AlertClientService,
                private router: RouterService,
                private notificationsService: NotificationsService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.triggerId) {
            if (!this.triggerId) {
                this.trigger = null;
                return;
            }

            this.loadingTrigger = true;
            this.alertClient.getTrigger(this.triggerId)
                .then(trigger => this.trigger = trigger)
                .catch(error => {
                    if (error instanceof HttpErrorResponse && error.status === 404) {
                        this.notificationsService.showError("INBOX_TRIGGER_NOT_FOUND", error);
                        this.router.mergeParams<StateParams>({ selected: null });
                    } else {
                        const message = getMessageForError(error.error, "FAILED_TO_RETRIEVE_TRIGGER");
                        this.notificationsService.showError(message, error);
                    }
                })
                .finally(() => this.loadingTrigger = false);
        }
    }

    onStateChanged(numAlertsRemaining: number) {
        this.onAlertsStateChanged.emit(numAlertsRemaining);
        this.triggerAlertsTable.refreshAlerts();
    }
}
